export class Model {
    id = '';
    code = '';
    name = '';
    operation = 'I';
    validFrom = '';
    validTo = '';
}
